const BUILD_VERSION = process.env.REACT_APP_BUILD_VERSION as string;
const build_version = BUILD_VERSION ? BUILD_VERSION : '0.0.1';

const ar = {
  'return': {
    'home': 'الرجوع إلى الصفحة الرئيسية',
  },
  'error': {
    'not_found': 'الصفحة غير موجودة',
    'components': {
      'paramsEmpty': 'params：{reason} can`t be empty',
    }
  },
  'whiteboard': {
    'loading': 'جار التحميل...',
  },
  'toast': {
    'api_login_failured': 'Join Failured, Reason: {reason}',
    'confirm': 'تأكيد',
    'cancel': 'إلغاء',
    'quit_room': 'هل انت متأكد تريد الخروج؟',
    'kick': 'kicked',
    'login_failure': 'خطأ في عملية الدخول',
    'whiteboard_lock': 'Whiteboard follow',
    'whiteboard_unlock': 'Whiteboard nofollow',
    'canceled_screen_share': 'تم إلغاء مشاركة الشاشة',
    'screen_sharing_failed': 'فشلت مشاركة الشاشة ، السبب: {reason}',
    'recording_failed': 'Start cloud recording failed, reason: {reason}',
    'start_recording': 'Start cloud recording success',
    'stop_recording': 'Stop cloud recording success',
    'recording_too_short': 'Recording too short, at least 15 seconds',
    'rtm_login_failed': 'خطأ تسجيل الدخول ، يرجى التحقق من الشبكة الخاصة بك',
    'rtm_login_failed_reason': 'خطأ تسجيل الدخول ، السبب: {reason}',
    'replay_failed': 'خطأ إعادة التشغيل ، يرجى تحديث المتصفح',
    'teacher_exists': ' المتحدث موجود، يرجى الانتظار لمدة 30 ثانية أو إعادة فتح جلسة جديدة',
    'student_over_limit': 'وصل الحضور إلى الحد الأقصى ، يرجى الانتظار لمدة 30 ثانية أو إعادة الانضمام إلى جلسة جديدة',
    'teacher_and_student_over_limit': 'بلغ عدد الحضور والمتحدثين الحد الأقصى',
    'teacher_accept_whiteboard': 'Speakeralready grant your whiteboard',
    'teacher_cancel_whiteboard': 'Speakeralready cancel your whiteboard',
    'teacher_accept_co_video': 'Speakeralready accept co-video',
    'teacher_reject_co_video': 'Speakeralready rejected co-video',
    'teacher_cancel_co_video': 'Speakeralready canceled co-video',
    'student_cancel_co_video': 'Attendee canceled co-video',
    'email_exists': 'هذا البريد الالكتروني مستخدم',
    'invalid_code': 'الرمز غير صحيح',
    'something_went_wrong': 'حدث خطأ ما حاول مرة أخرى!',
    'code_send': 'تم إرسال الرمز بنجاح!',
    'wrong_email_or_password': 'البريد الإلكتروني أو كلمة المرور خاطئة!',
    'newPasswordWrong': 'يجب مطابقة كلمة المرور الجديدة وتأكيد كلمة المرور!',
    'room_not-working': 'هذه الغرفة منتهية الصلاحية',
    'emailSent': "تفقد بريدك الالكتروني من فضلك",
    'passwordChanged': 'تم تغيير كلمة المرور بنجاح!',
    'currentPasswordIsWrong': 'كلمة المرور الحالية خاطئة!',
    'wrong_email': 'بريد إلكتروني خاطئ',
    'dataSaved': 'تم حفظ المعلومات بنجاح',
    'codeActivatedSuccessfully': 'تم تفعيل الرمز بنجاح',
    'correctPassword': 'كلمة المرور الصحيحة',
    'wrongRoomName': 'غرفة الاجتماع غير موجودة',
    'inActiveRoom': 'غرفة الاجتماع المدخلة غير فعالة',
    'passwordIsWrong': 'حدث خطأ ما حاول مرة أخرى!',
    'userBlocked': 'حسابك غير نشط ، يرجى الاتصال بمسؤول النظام.',
    'passwordsDontMatch': 'يجب مطابقة كلمات المرور!'
  },
  'notice': {
    'student_interactive_apply': `"{reason}" يريد التفاعل معك`
  },
  'chat': {
    'placeholder': 'دردشة ',
    'banned': 'محظور',
    'send': 'إرسال'
  },
  'device': {
    'camera': 'كاميرا',
    'microphone': 'ميكروفون',
    'speaker': 'المتحدث',
    'finish': 'حفظ',
  },
  'nav': {
    'delay': 'تأخير: ',
    'network': 'شبكة الاتصال: ',
    'cpu': 'CPU: ',
    'class_end': 'نهاية',
    'class_start': 'بداية'
  },


  'home': {
    'entry-home': 'انضم إلى الجلسة',
    'teacher': 'مسؤول المجموعة',
    'student': 'الحضور',
    'cover_class': 'cover-en',
    'room_name': 'اسم الغرفة',
    'nickname': 'اسمك',
    'room_type': 'نوع الغرفة',
    'room_join': 'انضم',
    'short_title': {
      'title': 'iHR Meet',
      'subtitle': 'Powered by iHR, a leading online learning engagement platform',
    },
    'name_too_long': 'name too long, should <= 20 characters',
    '1v1': 'One to One',
    'mini_class': 'Small Group',
    'meet_class': 'Meet Group',
    'large_class': 'Large Group',
    'missing_room_name': 'Missing room name',
    'missing_your_name': 'missing your name',
    'missing_password': 'missing password',
    'missing_role': 'missing role',
    'account': 'nickname',
    'password': 'password',
    "wrong_room_name": "Wrong room name!",
    "theSessionIsOld": "Session is old!",
    "missing_code": "Missing code",
    'missingPassword': 'Missing password',
    'missingConfirmPassword': 'Missing confirm password',
    'missingName': 'Missing name',
    'missingPhone': 'Missing phone',
    'wrongPassword': 'Wrong password',
    'wrongRoomName': 'غرفة الاجتماع غير موجودة',
    'missingField': 'Missing field',
    'joinRoomRole': 'Missing role',
  },
  'room': {
    'chat_room': 'الدردشة',
    'student_list': 'الحاضرين',
    'uploading': 'تحميل...',
    'converting': 'Converting...',
    'upload_success': 'upload success',
    'upload_failure': 'upload failure, check the network',
    'convert_success': 'convert success',
    'convert_failure': 'convert failure, check the network',
  },
  'replay': {
    'loading': 'loading...',
  },
  'build_version': `build version: ${build_version}`,
  'login': 'تسجيل الدخول',
  'email': 'البريد الإلكتروني',
  'password': 'كلمه السر',
  'fullName': 'الاسم الكامل',
  'register': 'تسجيل',
  'forgetPassword': 'هل نسيت كلمة المرور؟',
  'signIn': 'تسجيل الدخول',
  'send': 'إرسال',
  'name': 'الاسم',
  'country': 'البلد',
  'mobile': 'رقم الهاتف',
  'join2': 'انضمام',
  'register_new_account': 'تسجيل',
  'requiredField': 'حقل مطلوب',
  'enterCorrectEmailFormat': 'يرجى إدخال البريد الإلكتروني صحيح',
  'passwordLength': 'يجب أن تتكون كلمة المرور من 6 أحرف',
  'confirm_terms_conditions': ' لقد قرأت و وافقت على',
  'terms_conditions': ' شروط الاستخدام ',
  'areYouSureToLogOut': 'هل أنت متأكد أنك تريد تسجيل الخروج؟',
  'logout': 'خروج',
  'close': 'إغلاق',
  'personalId': 'معرّف الاجتماع الشخصي',
  'sendInvitation': 'إرسال دعوة',
  'start': 'بدء الاجتماع',
  'roomName': 'اسم الغرفة',
  'joinRoom': 'أو انضم الى اجتماع عبر اسم الغرفة ',
  'join': 'انضم',
  'editProfile': 'تعديل الملف الشخصي',
  'changePassword': 'تغيير كلمة المرور',
  'save': 'حفظ',
  'currentPassword': 'كلمة المرور الحالي',
  'newPassword': 'كلمة السر الجديدة',
  'confirmPassword': 'تأكيد كلمة المرور',
  'update': 'تحديث',
  'settings': 'الاعدادات',
  'linkCopied': 'تم نسخ الرابط!',
  'activation_code': 'رمز التفعيل',
  'enter_code': 'أدخل رمز هنا',
  'pleaseInsertActivationCode': 'يرجى إدخال رمز التفعيل',
  'toActivateYourAccount': 'لتفعيل حسابك',
  'activate': 'تفعيل',
  'reSendCode': 'إعادة إرسال رمز التفعيل',
  'mobileMsg': 'للانضمام إلى الاجتماع ، يرجى فتح الرابط من جهاز كمبيوتر أو تثبيت التطبيق من الروابط أدناه.',
  'newConfirmationPass': 'تأكيد كلمة السر الجديدة',
  'submit': 'إرسال',
  'shareLink': 'شارك الرابط',
  'roomPassword': 'كلمة المرور الغرفة',
  'adminPassword': 'كلمة سر المشرف',
  'connectPeople': 'لتبقى على اتصال',
  'or': 'أو',
  'joinMeeting': 'أو انضم الى اجتماع عبر اسم الغرفة ',
  'exit': 'خروج',
  'welcome': 'مرحبا',
  'roomCopied': '!تم نسخ الغرفة',
  'allFieldsRequired': 'جميع الحقول مطلوبة',
  'forgotPassword': 'نسيت كلمة المرور',
  'share_screen': 'مشاركة الشاشة',
  'members': 'الأعضاء',
  'share_your_screen': 'مشاركة الشاشة'
}

export default ar;